import * as React from "react";
import YouTube from 'react-youtube';
import {
    FacebookShareButton,
    VKShareButton,
} from 'react-share';

export interface ResultState {
    player:any,
    showBtns:boolean,
    played:boolean
}

export interface ResultProps{
    answerCorrectness:string,
    answersCount:number,
    rightAnswersCount:number,
    videoId:string,
    hideVideo:boolean
}

export class Result extends React.Component<ResultProps,ResultState>{
    constructor(props){
        super(props);
        this.state={
            player:null,
            showBtns:false,
            played:false
        };
        this.startV     = this.startV.bind(this)
    }

    private share(socNetwork,e) {

    }

    private static reload(e) {
        window.location.reload();
    }
    componentDidMount() {
        /*let audioPlayer: any = document.getElementById('vid');
        audioPlayer.play();*/
    }
    componentDidUpdate() {
        /*let audioPlayer: any = document.getElementById('vid');
        audioPlayer.play();*/
        if(this.state.player) {
            if (this.props.hideVideo) {
                this.state.player.target.pauseVideo();
            } else if(!this.state.played) {
                this.state.player.target.playVideo();
                this.setState({played:true});
                setTimeout(
                    function () {
                        this.setState({showBtns:true});
                    }.bind(this),
                    18000
                );
            }
        }
    }

    pauseV(event) {
        //alert('paused');
    }
    endV(event) {
        //alert('ended1');
        let duration:number = event.target.getDuration();
        event.target.seekTo(duration,true);
        event.target.stopVideo();
    }
    startV(event) {
        if(this.state.player==null) {
            this.setState({
                player: event
            });

        }
        //console.log( event);

        //event.target.playVideo();
    }

    render() {
        let vw:number = window.innerWidth;
        let vh:number = window.innerHeight;
        let frameWidth:number;
        let videoHeight:number;
        if(vw<900){//mobile
            videoHeight = vw;
            /*if(vh*.4>vw) {
                videoHeight=vw;
            } else {
                videoHeight=vh*.4;
            }*/
        } else {
            //videoHeight = document.getElementsByClassName('frame')[0].clientWidth;
            videoHeight =  +window.getComputedStyle(document.querySelector('html'), null).getPropertyValue('font-size').slice(0,-2)*48.938;
            //console.log(videoHeight);
            //console.log(window.getComputedStyle(document.querySelector('html'), null));
            //console.log(window.getComputedStyle(document.querySelector('html'), null).getPropertyValue('font-size'));
            //console.log(+window.getComputedStyle(document.querySelector('html'), null).getPropertyValue('font-size'));
            //console.log(+window.getComputedStyle(document.querySelector('html'), null).getPropertyValue('font-size').slice(0,-2));
            //videoHeight = frameWidth;
        }
        const opts = {
            height: videoHeight,
            width: videoHeight,
            allowFullScreen: false,
            doNotAllowFullScreen: '1',
            donotallowfullscreen: '1',
            playerVars: { // https://developers.google.com/youtube/player_parameters
                controls:0,
                showinfo:0,
                iv_load_policy:3,
                fs:0,
                disablekb:1,
                modestbranding:1,
                rel:0,
                autoplay:0,
                playsinline:1
            }
        };

        let phrase:string;
        if( this.props.rightAnswersCount < 2 ) {
            phrase = "Я фэшн табуретка";
        } else if ( this.props.rightAnswersCount < 4 ) {
            phrase = "Что-то смыслю в шмоте";
        } else {
            phrase = "Я фэшн конфетка";
        }
        return (
            <div>
                <div className={'frame _start-image' + (this.props.hideVideo ? ' _hidden' : '')}>
                    <YouTube videoId={this.props.videoId} opts={opts} onPause={this.pauseV.bind(this)} onEnd={this.endV.bind(this)} onReady={this.startV.bind(this)}/>
                    <div className={'result-bottom-line' + (this.state.showBtns ? '' : ' _transparent')}>
                        <div className={'result-info'}>
                            <div className={'result-count'}>
                                {this.props.rightAnswersCount}/{this.props.answersCount}
                            </div>
                            <div className={'result-title'}>
                                <div className={'vertical-center-absolute'}>
                                    {phrase}
                                </div>
                            </div>
                        </div>
                        <div className={'final-buttons'}>
                            {/*<div className={'button _share _vk'} onClick={this.share.bind(this,'vk')}>
                                <svg className='svg-icon share _vk'>
                                    <use xlinkHref='#icon-vk' />
                                </svg>
                            </div>*/}
                            <div className={'button _share _vk'} onClick={this.share.bind(this,'vk')}>
                                <VKShareButton
                                    url={'https://luivagon.friday.ru?r_id='+this.props.rightAnswersCount}
                                    className="wide-absolute-link"
                                    title={'Тест от Луи Вагон. Фэшн конфетка или фэшн табуретка?'}
                                    image={'https://luivagon.friday.ru/share/podium_vagon_snippet_968_504-'+this.props.rightAnswersCount+'.jpg'}
                                >
                                </VKShareButton>
                                <svg className='svg-icon share _vk'>
                                    <use xlinkHref='#icon-vk' />
                                </svg>
                            </div>
                            <div className={'button _share _fb'} onClick={this.share.bind(this,'fb')}>
                                <FacebookShareButton
                                    url={'https://luivagon.friday.ru?r_id='+this.props.rightAnswersCount}
                                    className="wide-absolute-link">
                                </FacebookShareButton>
                                <svg className='svg-icon share _fb'>
                                    <use xlinkHref='#icon-fb' />
                                </svg>
                            </div>
                            {/*<div className={'button _share _fb'} onClick={this.share.bind(this,'fb')}>
                                <svg className='svg-icon share _fb'>
                                    <use xlinkHref='#icon-fb' />
                                </svg>
                            </div>*/}
                            <div className={'button _share'}   onClick={Result.reload}>
                                <svg className='svg-icon share _reload'>
                                    <use xlinkHref='#icon-one-more' />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}